import { Table } from 'antd';
import { Table as TableV5, TableProps } from 'antd-v5';
import css from './index.module.scss';
import Crum from '@/components/Crum';
import SupportBanner from '@/components/SupportCommon/SupportBanner';
import SupportContactUs from '@/components/SupportCommon/SupportContactUs';
import SupportTitle from '@/components/SupportCommon/SupportTitle';
import EFArrowDown from '@/components/UI/svg/Icons/EFArrowDown';
import SupportBannerH5 from '@/componentsH5/SupportCommon/SupportBanner';
import SupportContactUsH5 from '@/componentsH5/SupportCommon/SupportContactUs';
import SupportTitleH5 from '@/componentsH5/SupportCommon/SupportTitle';
import { useGlobal } from '@/utils/useGlobal';

type WarrantyTableItem = { series: string; item: string; warranty: string; key: number };

export default function OldSupportPolicy({ lang }: any) {
    const { useState, useEffect, isMobile, useLang, gtm, useRouter } = useGlobal();
    const { locale } = useRouter();
    const countryText = locale === 'us' ? 'us' : 'ca';
    const policyList = [
        {
            key: 'p1',
            text: 'Overview',
            isContainTable: true,
        },
        {
            key: 'p2',
            text: 'Warranty Period',
            isContainTable: true,
        },
        {
            key: 'p3',
            text: 'Return, Refund & Replacement Services',
            value: `
      3.1 Eligibility & Conditions for Unconditional Returns<br />
      a. The unconditional return policy applies only to products ordered through <a href="https://www.ecoflow.com/">EcoFlow.com</a> in the United States. EcoFlow does not accept unconditional returns for products purchased through other channels; please contact your point of purchase first.<br />
      b. Customers must request a return within thirty (30) calendar days from the day after receiving the product. The receipt date is determined by the shipping tracking record or proof of delivery. If the shipping information appears abnormal or contains obvious errors, EcoFlow reserves the right to make a reasonable determination based on the actual circumstances. For returns not related to product quality issues, if the request is submitted after the deadline, the company reserves the right to refuse the request or deny a refund.<br />
      c. For unconditional returns, customers must confirm with EcoFlow Customer Service before requesting a refund. For specific procedures, please refer to: Product Return Process.<br />
      d. Customers may request a full refund within 24 hours of placing an order on <a href="https://www.ecoflow.com/">ecoflow.com</a>. <br />
      e. Please note that if you request a refund more than 24 hours after placing your order and before the item has been shipped, we will charge a processing fee (2.6% for credit card users, 3.6% for PayPal users, and 3.3% for Klarna users). <br />
      f. Orders cannot be canceled more than 30 days after shipment.<br />
      g. You may request a return or exchange without cause within 30 days of receiving the product. If the product has a quality issue, you may request repair, replacement, or other remedies within 30 days or during the warranty period in accordance with these Limited Warranty Terms. The 30-day no-questions-asked return and exchange policy does not affect your rights under the warranty policy. <br />
      <br /><br />
      3.2 Requirements of Refunds & Replacements<br />
      Without affecting the statutory rights consumers are entitled to by law, any requests for refunds or exchanges must meet all of the following conditions： <br />
      a. The product must be in perfect condition, free from damage or signs of use, and in its original, resalable condition;  <br />
      b.The product must be returned along with all original packaging; <br />
      c. To ensure that accessories and parts remain intact and to prevent damage during shipping, please pack the item securely before returning it; <br />
      d. All accessories, parts, and included promotional items must be returned together; if promotional items are not returned, the company reserves the right to deduct their suggested retail price from the refund amount. <br />
      Return or exchange requests that do not meet the above conditions may be denied.
      <br /><br />
      3.3 Shipping Fees and Refund Policy<br />
      a. Return Shipping Costs for Non‑Defective Items <br />
      If the return is due to non‑quality related reasons, the customer shall be responsible for all related logistics costs and transaction fees. The refund will be limited to the actual purchase price of the item. Shipping fees and any other additional charges (including but not limited to handling fees, duties, or taxes) are non‑refundable, and the original shipping cost actually incurred will be deducted as applicable. <br />
      b. Refunds for Bundled Products <br />
      For bundled or multi‑item orders, all products included in the order must be returned together. If only one item from the bundle is returned, the refund amount will be calculated as the total amount paid minus the manufacturer’s suggested retail price (MSRP) of the remaining item(s) that are not returned. <br />
      c. Warranty‑Related Returns (Quality Issues) <br />
      – Within the warranty period: If the return or exchange is caused by a confirmed product quality issue, EcoFlow shall be responsible for the shipping costs for both the return and the replacement shipment. <br />
      – Outside the warranty period or due to user‑caused damage: The customer will be responsible for all related logistics costs, including but not limited to transportation, customs duties, taxes, and clearance fees. <br />
      <br /> <br />
      3.4 Product Return&Replacement  Process<br />
      a. Our customer service team will review your order to determine if it meets the return and exchange criteria. Once we confirm that your order qualifies, we will provide you with a Return Merchandise Authorization (RMA) number and a prepaid return shipping label (the shipping label will be provided by our support team). We will also provide product packaging instructions to ensure you can return the product safely. Please do not ship the product until you have received the correct packaging instructions; you must clearly mark the RMA number on the package and include proof of purchase with the product;
      <br />
      b. Once you have received an RMA number, you must ship the relevant product within fifteen (15) calendar days from the date the number was issued, or within any other timeframe specified by EcoFlow. Please do not return the product before receiving an RMA number from the EcoFlow Customer Support Team. When returning the product, you must clearly mark the RMA number on the outside of the package and include valid proof of purchase (such as an order record or invoice). Return or exchange requests that do not meet the above requirements may not be accepted.
      <br />
      c. Returned products will be inspected at EcoFlow or an EcoFlow-authorized service center. If the inspection confirms that the product meets EcoFlow’s return requirements, a refund or exchange will be processed in accordance with applicable policies;
      <br /><br />

      3.5 Handling of Items That Fail Inspection<br />
      If, upon inspection by EcoFlow or its authorized service center, the returned product does not meet the return criteria, EcoFlow reserves the right to refuse the refund or exchange request, or to adjust the refund amount accordingly (including, but not limited to, deductions for missing accessories, promotional gifts, or depreciation in the product’s value). In such cases, the product will generally be returned to you, or handled in a manner mutually agreed upon by both parties.
      <br />
      If the product cannot be returned due to your failure to respond or provide valid shipping information, or if the product is returned during the return process due to undeliverability or refusal of delivery, EcoFlow will store the product free of charge for 14 days starting from the date of the last contact with you or the date the product is returned to EcoFlow. After this period expires, if you have not provided further instructions, EcoFlow may continue to store the goods on your behalf and charge you for reasonable storage and handling fees incurred (specific fee schedules will be disclosed to you in advance). If you have not collected the goods or provided disposal instructions within the free storage period, and the associated costs exceed the reasonable value of the goods, EcoFlow reserves the right to dispose of the goods in accordance with applicable laws.
      <br />
      <br />
      3.6 Policy of Refunds & Replacements & Refund Processing Time
      <br />
      a. For returns of US orders and if the product is in good condition, we'll charge a transaction fee (2.6% for credit card users, 3.6% for PayPal users, 3.3% for Klarna users) and double shipping fee. If there are quality issues with your product, we will give you a full refund or one-time free replacement after you receive the goods;（For shipping rates, please refer to the following link: <a href="https://${countryText}.ecoflow.com/pages/ecoflow-return-policy">https://${countryText}.ecoflow.com/pages/ecoflow-return-policy</a>）
      <br />
      b. Once EcoFlow receives your refund request, we will process the refund within 5 business days after the returned item arrives at our warehouse and is inspected to ensure it meets the return criteria. We will notify you via email once the refund has been processed. If you have not received your refund after 5 business days, please contact <a mailto="support@ecoflow.com">support@ecoflow.com</a>;
      <br />
      c. Upon receiving your exchange request, EcoFlow will ship the replacement item within 7 business days after the returned item arrives at our warehouse and is verified to meet the return criteria.
      <br />
      d. Refunds will be processed after the returned item arrives at our warehouse and is verified to meet the return criteria.
      <br />
      e. Refunds will be issued to the account you used for payment via the original payment method. Refund processing typically takes 5 to 7 business days; the exact time it takes for the refund to appear in your account may vary depending on the payment provider or bank’s processing procedures.
      <br /><br />
      3.7 What is not covered Return, Refund & Replacement Services
      <br />
      a. the refund/replacement request is made more than 30 days after receiving the product.
      <br />
      b. the product is returned without confirmation by EcoFlow customer service team.
      <br />
      c. legal proof-of-purchase, receipts, or invoices are not provided, can’t be found, or are reasonably believed to have been forged or tampered with.
      <br />
      d. a product sent to EcoFlow does not include all the original accessories, attachments, and packaging, or it contains items damaged by user error.
      <br />
      e. evidence is found of damage caused by collision, scorching, or unauthorized use or modification of the roduct, including exposure to moisture or water, entry of other foreign items (including but not limited to oil, sand, etc.) or improper installation or operation of the product is found.
      <br />
      f. product labels, serial numbers, water damage marks, etc., show signs of tampering or alteration.
      <br />
      g. the product has not been sent back to EcoFlow within 15 calendar days after confirmation from EcoFlow.
      <br />
      h.  normal wear and tear (including, without limitation, wear and tear of batteries, if applicable).
      <br />
      i. defects caused by rough or inappropriate handling or use or damage caused by accident,misuse,negligence, fire, water, lightning or other acts of nature.
      <br />
      j. if the Product contains a battery and the battery has been short-circuited, if the seals of the battery enclosure or the cells are broken or show evidence of tampering or if the battery has been used in equipment other than those for which it has been specified.
      <br />
      k. non-compliance with the Product instructions.
      <br />
      l. use of spare parts, or other replacement items (including consumables) which are not provided or recommended by us.
      <br />
      m. any alteration or modification to the Product which has been carried out by you or a third party not authorized by us.
      <br />
      n. extreme or external causes beyond our reasonable control including, but not limited to, breakdowns, fluctuations, or interruptions in electric power, or wireless networks.
      <br />
      o. any Product(s) purchased from unauthorized sellers/dealers/resellers.
      <br />
      p. use or operate in an environment with electromagnetic interference (i.e. In mining areas or close to radio transmission towers, high-voltage wires, substations, etc.).
      <br />
      q. unauthorized modification of circuits and mismatch or misuse of the battery and charger.
      <br />
      r.  connection to an improper power supply,
      <br />
      s. use of the equipment in conjunction with third-party accessories, products, or ancillary peripheral equipment.
      <br />
      t. equipment where the manufacturer’s serial number has been altered, deleted, removed, or made illegible.
      <br />
      u. equipment which has been adjusted or adapted without EcoFlow’s prior written consent, including (but not limited to): upgrading the equipment beyond specifications or features described in the instruction manual, or modifications to the equipment to conform it to national or local technical or safety standards in countries other than those for which the equipment was specifically designed and manufactured.
      <br />
      v. consumable parts.
      <br />
      w. products that are lost, stolen, or provided free of charge, including promotional or giveaway items,
      <br />
      x. damage or loss to any software programs, data, or removable storage media costs associated with de-installation, re-installation, or integration into a system.
      <br />
      y. Other circumstances that are not stated in this policy, but EcoFlow has sufficient proof to refuse.
      `,
        },
        {
            key: 'p4',
            text: 'Repair Service',
            isContainTable: true,
        },
        {
            key: 'p5',
            text: 'Limited International Warranty Service',
            isContainTable: true,
        },
        {
            key: 'p6',
            text: 'Cross-Regional After-Sales Services',
            value: `
      a. EcoFlow does not provide global warranty for products, and the warranty service can only be fulfilled at a designated EcoFlow repair center.<br />
      b. To repair the product at an EcoFlow repair center and in the event that the product was purchased in another region, customers can still apply for a repair at an additional cost (depending on spare part availability). Some products do not support cross-regional repair even if the customer is willing to pay for the service. For more details, please contact EcoFlow Support.<br />
      c. Cross-regional replacement service is not available for different versions of the same product.<br />
      d. The customer will need to bear customs duties, taxes, customs clearance, and other costs incurred due to cross-regional repair, regardless of whether it is regarding the warranty repair service or the paid repair service.<br />
      <br /><br />
      `,
        },
        {
            key: 'p7',
            text: 'Refurbished Product Aftersales Policy',
            value: `
      a. All refurbished products meet the normal required standards for use and can be used just as with an ordinary unit. <br />
      b. Refurbished units are produced and certified by EcoFlow and can therefore benefit from the same after-sales services, including warranty. However, if a replacement is required, reasoning related to appearance, or applications without reason will not be accepted. <br />
      c. Customers should ensure the refurbished product has been purchased from an authorized seller. The serial number of the product should match our database records. If the product is not found in our database, the service will not apply. <br />
      <br /><br />
      `,
        },
        {
            key: 'p8',
            text: 'Logistics Policy',
            value: `
      a. Customers need to check the product for damages before signing for receival. If there are any problems, please contact EcoFlow and provide the corresponding certification or proof.
      When signing receival for products, the customer needs to check whether the product is intact and undamaged. If left unchecked, it will be deemed that the customer considers that the product is functioning and not damaged. If the product is damaged during transportation, please contact EcoFlow within 24 hours;
      <br /> b. In the event that the customer sends a product to EcoFlow without advance authorization from EcoFlow’s after-sales team, EcoFlow has the right to reject the package, and any loss or damage shall be covered by customer;
      <br /> c. If the customer sends a product back to EcoFlow by COD (cash-on-delivery) without the authorization of EcoFlow in advance, the package may be rejected due to payment failure; the customer shall bear any direct or indirect loss during this operation;
      <br /> d. The customer shall send back the product to the specified and unique address according to instruction of the EcoFlow service team. In the event that a product is sent to any other address by mistake, EcoFlow shall not be responsible for safety or transferring of product, even if the address is relevant to EcoFlow;
      <br /> e. The customer needs to make sure that the receiving addresses are correct and are updated. If the receiving address provided by the customer is wrong, or the recipient refuses to receive the product, the loss caused shall be covered by the customer.
      <br /> f. Customs Clearance: EcoFlow will not bear any customs clearances incurred.
      <br /> <br /> `,
        },
        {
            key: 'p9',
            text: 'What to do Before Requesting After-Sales Service',
            value: `
      Before requesting after-sales service, the following steps must be taken:<br />
      √Follow the service procedures specified by EcoFlow;<br />
      √Follow the instructions of the EcoFlow service team and provide a product defect description and any relevant information of recipient;<br />
      √Remove all additional parts. Alterations and attachments are not covered under warranty;<br />
      √Ensure that the product or parts are free of any legal restrictions that prevent repair or replacement.<br />
      <br /><br />
      `,
        },
        {
            key: 'p10',
            text: 'What This After-Sales Policy Does Not Cover',
            value: `
      In situations not covered by this policy, the customer and EcoFlow will work together to find a solution based on the facts and evidence.
      <br /><br />
      `,
        },
        {
            key: 'p11',
            text: 'Limitation of Liability',
            value: `
      WHEN RECEIVING SERVICE, EcoFlow IS RESPONSIBLE FOR LOSS OR DAMAGE TO YOUR PRODUCT ONLY WHILE IT IS IN EcoFlow'S POSSESSION OR IN TRANSIT, IF EcoFlow IS RESPONSIBLE FOR TRANSPORTATION.<br />
      UNDER NO CIRCUMSTANCES, AND NOTWITHSTANDING THE FAILURE OF ESSENTIAL PURPOSE OF ANY REMEDY SET FORTH HEREIN, SHALL EcoFlow, ITS AFFILIATES, SUPPLIERS, RESELLERS, OR SERVICE PROVIDERS BE LIABLE FOR ANY OF THE FOLLOWING EVEN IF INFORMED OF THEIR POSSIBILITY AND REGARDLESS OF WHETHER THE CLAIM IS BASED IN CONTRACT, WARRANTY, NEGLIGENCE, STRICT LIABILITY OR OTHER THEORY OF LIABILITY:<br />
      1) THIRD PARTY CLAIMS AGAINST YOU FOR DAMAGES;<br />
      2) SPECIAL, INCIDENTAL, PUNITIVE, INDIRECT, OR CONSEQUENTIAL DAMAGES, INCLUDING BUT NOT LIMITED TO LOST PROFITS, BUSINESS REVENUE, GOODWILL, OR ANTICIPATED SAVINGS. IN NO CASE SHALL THE TOTAL LIABILITY OF EcoFlow, ITS AFFILIATES, SUPPLIERS, RESELLERS, OR SERVICE PROVIDERS FOR DAMAGES FROM ANY CAUSE EXCEED THE AMOUNT OF ACTUAL DIRECT DAMAGES, NOT TO EXCEED THE AMOUNT PAID FOR THE PRODUCT.
      THE FOREGOING LIMITATION DOES NOT APPLY TO DAMAGES FOR BODILY INJURY (INCLUDING DEATH), DAMAGE TO REAL PROPERTY OR DAMAGE TO TANGIBLE PERSONAL PROPERTY FOR WHICH EcoFlow IS LIABLE UNDER LAW.<br />
      AS SOME STATES OR JURISDICTIONS DO NOT ALLOW THE EXCLUSION OR LIMITATION OF INCIDENTAL OR CONSEQUENTIAL DAMAGES, THE ABOVE LIMITATION OR EXCLUSION MAY NOT APPLY TO YOU.
      <br /><br />
      `,
        },
        {
            key: 'p12',
            text: 'Your Other Rights',
            value: `This policy provides you with extra and specific legal rights. You may have other rights according to the applicable laws of your state or jurisdiction. You may also have other rights under a written agreement with EcoFlow. Nothing in this policy affects your statutory rights, including rights of consumers under laws or regulations governing the sale of consumer products that cannot be waived or limited by agreement.`,
        },
        {
            key: 'p13',
            text: 'Interpretation Rights',
            value: `* EcoFlow reserves the right of final interpretation of the above customers' after-sales policy.`,
        },
    ];
    const [anchorText, setAnchorText] = useState('Overview');
    const [tabActive, setTabActive] = useState(0);
    const [isShowNav, setIsShowNav] = useState(false);
    const { t } = useLang('shared');
    const breadcrumbData = [{ name: t('crums.crum_home'), link: '/' }, { name: t('crums.crum_support'), link: '/support' }, { name: t('crums.crum_policy') }];

    const handleTabClick = (e: any, ind: number, text: string) => {
        const { className, offsetTop, offsetHeight } = e.target;
        const key = e.target.getAttribute('data-key');
        if (className && className === 'active') return false;

        const targetEle: any = document.querySelector('.tabs-ink-bar');
        if (targetEle.style) {
            targetEle.style.top = `${offsetTop}px`;
            targetEle.style.height = `${offsetHeight}px`;
        }

        setTabActive(ind);
        scrollToAnchor(`#${key}`);
        gtm.push({
            event: 'uaEvent',
            event_name: 'policy_navigation',
            navigation_name: text || '',
        });
    };

    const mHandleTabClick = (e: any, ind: number, text: string) => {
        const key = e.target.getAttribute('data-key');
        setAnchorText(text);
        setTabActive(ind);
        scrollToAnchor(`#${key}`);
        setIsShowNav(false);
        gtm.push({
            event: 'uaEvent',
            event_name: 'policy_navigation',
            navigation_name: text || '',
        });
    };

    useEffect(() => {
        if (!isMobile) {
            const targetEle: any = document.querySelector('.tabs-ink-bar');
            if (targetEle.style) {
                targetEle.style.height = `70px`;
                targetEle.style.top = '56px';
            }
        }
    }, []);

    return (
        <div className={`${css.supportPolicy}`}>
            {isMobile ? <SupportBannerH5 /> : <SupportBanner />}
            <Crum data={breadcrumbData} />
            <div className={`${css.accessories} container`}>
                <div className="accessories-box">
                    {isMobile ? <SupportTitleH5 title={lang.title} /> : <SupportTitle title={lang.title} />}
                    {isMobile && (
                        <div className={`policy-access-tab-top ${isShowNav ? 'nav-active' : ''}`} onMouseLeave={() => setIsShowNav(false)}>
                            <div className="policy-access-tab-top-wrapper" onClick={() => setIsShowNav(!isShowNav)}>
                                <span className="anchor-text">{anchorText}</span>
                                <div className="iconBox">
                                    <EFArrowDown />
                                </div>
                            </div>
                            {isShowNav && (
                                <div className="vertical-nav">
                                    <ul>
                                        {policyList.map((item: any, ind: number) => (
                                            <li
                                                key={ind}
                                                data-key={item.key}
                                                className={tabActive === ind ? 'active' : ''}
                                                onClick={(e) => mHandleTabClick(e, ind, item.text)}
                                            >
                                                {item.text}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            )}
                        </div>
                    )}
                    <div className="content">
                        <div className="policy-access-wrapper">
                            {!isMobile && (
                                <div className="policy-access-tab">
                                    <ul>
                                        {policyList.map((item: any, ind: number) => (
                                            <li
                                                key={ind}
                                                data-key={item.key}
                                                className={tabActive === ind ? 'active' : ''}
                                                onClick={(e) => handleTabClick(e, ind, item.text)}
                                            >
                                                {item.text}
                                            </li>
                                        ))}
                                    </ul>
                                    <div className="tabs-ink-bar tabs-ink-bar-animated"></div>
                                </div>
                            )}

                            <div className="policy-access-content" id="container">
                                {policyList.map((item: any, indx: number) => {
                                    if (item.isContainTable) {
                                        return <Fragment key={indx} id={item.key} tabActive={tabActive} isMobile={isMobile} locale={locale} />;
                                    } else {
                                        return (
                                            <div
                                                id={item.key}
                                                key={item.key}
                                                className={`policycontent-item policy-access-content-item ${
                                                    item.key == `p${parseInt(tabActive) + 1}` ? 'active' : ''
                                                }`}
                                            >
                                                <h3>{item.text}</h3>
                                                <div
                                                    dangerouslySetInnerHTML={{
                                                        __html: item.value,
                                                    }}
                                                    style={{ color: '#35404e' }}
                                                ></div>
                                            </div>
                                        );
                                    }
                                })}
                                <div className="footer-tip">
                                    {'This limited warranty policy only applies to EcoFlow products purchased in North America through formal channels.'}
                                </div>
                            </div>
                        </div>
                    </div>
                    {isMobile ? <SupportContactUsH5 isShow={true} /> : <SupportContactUs isShow={true} />}
                </div>
            </div>
        </div>
    );
}

// 处理包含table内容的项
function Fragment({ id, tabActive, isMobile, locale }: any) {
    const NA_Text = locale === 'us' ? 'NA/US' : 'NA/CA';
    const countryText = locale === 'us' ? 'us' : 'ca';
    const p1Columns = [
        {
            title: 'DELTA Series',
            dataIndex: 'ds',
            key: 'DELTA Series',
        },
        {
            title: 'RIVER Series',
            dataIndex: 'rs',
            key: 'RIVER Series',
        },
        {
            title: 'Solar Panels',
            dataIndex: 'sp',
            key: 'Solar Panels',
        },
        {
            title: 'Ecosystem Products',
            dataIndex: 'ep',
            key: 'Ecosystem Products',
        },
        {
            title: 'Power Banks',
            dataIndex: 'pb',
            key: 'Power Banks',
        },
        {
            title: 'Accessories,  Extra Batteries',
            dataIndex: 'aeb',
            key: 'Accessories,  Extra Batteries',
        },
    ];

    const p1Data: any = [
        {
            key: 1,
            ds: 'DELTA Pro',
            rs: 'RIVER Pro',
            sp: '400W',
            ep: 'Smart Home Panel',
            pb: 'RIVER Bank',
            aeb: 'DELTA Pro Smart Extra Battery',
        },
        {
            key: 2,
            ds: 'DELTA Max',
            rs: 'RIVER Max',
            sp: '160W',
            ep: 'Smart Generator',
            pb: 'RAPID Power Bank',
            aeb: 'DELTA Max Smart Extra Battery',
        },
        {
            key: 3,
            ds: 'DELTA1000',
            rs: 'RIVER',
            sp: '110W',
            ep: 'Double Voltage Hub',
            pb: 'RAPID Plus Power Bank',
            aeb: 'RIVER Pro Extra Battery',
        },
        {
            key: 4,
            ds: 'DELTA Mini',
            rs: 'R600 Pro',
            sp: '85W',
            ep: 'EV X-Stream Adapter',
            pb: '',
            aeb: 'RIVER Extra Battery',
        },
        {
            key: 5,
            ds: 'DELTA',
            rs: 'R600 Max',
            sp: '60W',
            ep: 'Solar Tracker',
            pb: '',
            aeb: 'Cables & Chargers',
        },
        {
            key: 6,
            ds: '',
            rs: 'R600',
            sp: '50W',
            ep: '',
            pb: '',
            aeb: 'Cases',
        },
        {
            key: 7,
            ds: '',
            rs: 'RIVER 412',
            sp: '21W',
            ep: '',
            pb: '',
            aeb: '',
        },
        {
            key: 8,
            ds: '',
            rs: 'RIVER 370',
            sp: '',
            ep: '',
            pb: '',
            aeb: '',
        },
    ];

    const p2Data: WarrantyTableItem[] = [
        {
            key: 1,
            series: 'DELTA Series',
            item: 'DELTA Max (1600/2000)',
            warranty: '24; or 24 +12 (Subject to registration)',
        },
        {
            key: 2,
            series: 'DELTA Series',
            item: 'DELTA Pro',
            warranty: '24; or 24 +36 (Subject to registration)',
        },
        {
            key: 3,
            series: 'DELTA Series',
            item: 'DELTA',
            warranty: '24',
        },
        {
            key: 4,
            series: 'DELTA Series',
            item: 'DELTA Mini',
            warranty: '24',
        },
        {
            key: 5,
            series: 'DELTA Series',
            item: 'DELTA 2',
            warranty: '5 years',
        },
        {
            key: 6,
            series: 'DELTA Series',
            item: 'DELTA 2 Max',
            warranty: '5 years',
        },
        {
            key: 7,
            series: 'DELTA Series',
            item: 'DELTA Pro 3',
            warranty: '5 years',
        },
        { key: 8, series: 'DELTA Series', item: 'DELTA 3', warranty: '5 years' },
        { key: 9, series: 'DELTA Series', item: 'DELTA 3 Plus', warranty: '5 years' },
        { key: 10, series: 'DELTA Series', item: 'DELTA 3 1500', warranty: '5 years' },
        { key: 11, series: 'DELTA Series', item: 'DELTA Pro Ultra Inverter', warranty: '5 years' },
        { key: 12, series: 'DELTA Series', item: 'DELTA Pro Ultra X Inverter', warranty: '5 years' },
        { key: 13, series: 'DELTA Series', item: 'DELTA 3 Classic', warranty: '3+2 years (Subject to registration)' },
        { key: 14, series: 'DELTA Series', item: 'DELTA 3 Max', warranty: '3+2 years (Subject to registration)' },
        { key: 15, series: 'DELTA Series', item: 'DELTA 3 Max Plus', warranty: '3+2 years (Subject to registration)' },
        { key: 16, series: 'DELTA Series', item: 'DELTA 3 Ultra', warranty: '3+2 years (Subject to registration)' },
        { key: 17, series: 'DELTA Series', item: 'DELTA 3 Ultra Plus', warranty: '3+2 years (Subject to registration)' },
        { key: 18, series: 'DELTA Series', item: 'DELTA 3 1000 Air', warranty: '2 years' },
        { key: 19, series: 'Extra Battery Series', item: 'DELTA Max Smart Extra Battery', warranty: '24; or 24 +12 (Subject to registration)' },
        { key: 20, series: 'Extra Battery Series', item: 'DELTA Pro Smart Extra Battery', warranty: '24; or 24 +36 (Subject to registration)' },
        { key: 21, series: 'Extra Battery Series', item: 'DELTA 2 Extra Battery', warranty: '5 years' },
        { key: 22, series: 'Extra Battery Series', item: 'DELTA Pro 3 Extra Battery', warranty: '5 years' },
        { key: 23, series: 'Extra Battery Series', item: 'DELTA Pro Ultra Battery', warranty: '5 years' },
        { key: 24, series: 'Extra Battery Series', item: 'DELTA Pro Ultra X Battery', warranty: '5 years' },
        { key: 25, series: 'Extra Battery Series', item: 'RIVER Extra Battery', warranty: '24' },
        { key: 26, series: 'Extra Battery Series', item: 'RIVER Pro Extra Battery', warranty: '24' },
        { key: 27, series: 'Extra Battery Series', item: 'RIVER 3 Plus Smart Extra Battery', warranty: '5 years' },
        { key: 28, series: 'Extra Battery Series', item: 'DELTA 3 Max Extra Battery', warranty: '36 +24 (Subject to registration)' },
        { key: 29, series: 'RIVER Series', item: 'R600/R600 Max/R600 Pro/EF-1500*', warranty: '36' },
        { key: 30, series: 'RIVER Series', item: 'RIVER mini', warranty: '24' },
        { key: 31, series: 'RIVER Series', item: 'RIVER', warranty: '24' },
        { key: 32, series: 'RIVER Series', item: 'RIVER Max', warranty: '24' },
        { key: 33, series: 'RIVER Series', item: 'RIVER Max Plus', warranty: '24' },
        { key: 34, series: 'RIVER Series', item: 'RIVER Pro', warranty: '24' },
        { key: 35, series: 'RIVER Series', item: 'RIVER 2', warranty: '5 years' },
        { key: 36, series: 'RIVER Series', item: 'RIVER 2 Max', warranty: '5 years' },
        { key: 37, series: 'RIVER Series', item: 'RIVER 2 Pro', warranty: '5 years' },
        { key: 38, series: 'RIVER Series', item: 'RIVER 3 Plus', warranty: '5 years' },
        { key: 39, series: 'RIVER Series', item: 'RIVER 3', warranty: '24' },
        { key: 40, series: 'RIVER Series', item: 'RIVER 3 Max', warranty: '5 years' },
        { key: 41, series: 'RIVER Series', item: 'EcoFlow RIVER 3 Max Plus', warranty: '5 years' },
        { key: 42, series: 'Solar Panel Series', item: '400W Portable Solar Panel', warranty: '12' },
        { key: 43, series: 'Solar Panel Series', item: '220W Portable Solar Panel', warranty: '12' },
        { key: 44, series: 'Solar Panel Series', item: '160W Portable Solar Panel', warranty: '12' },
        { key: 45, series: 'Solar Panel Series', item: '110W Portable Solar Panel', warranty: '12' },
        { key: 46, series: 'Solar Panel Series', item: '85W Portable Solar Panel', warranty: '12' },
        { key: 47, series: 'Solar Panel Series', item: '60W Portable Solar Panel', warranty: '12' },
        { key: 48, series: 'Solar Panel Series', item: '45W Portable Solar Panel（Discontinued）', warranty: '12' },
        { key: 49, series: 'Solar Panel Series', item: '400W Rigid Solar Panel', warranty: '10 years' },
        { key: 50, series: 'Solar Panel Series', item: '100W Rigid Solar Panel', warranty: '5 years' },
        { key: 51, series: 'Solar Panel Series', item: '100W Flexible Solar Panel', warranty: '3 years' },
        { key: 52, series: 'Solar Panel Series', item: '125W Bifacial Modular Solar Panel', warranty: '5 years' },
        { key: 53, series: 'Solar Panel Series', item: '130W RVMax Rigid Solar Panel', warranty: '5 years' },
        { key: 54, series: 'Solar Panel Series', item: '28W Portable Solar Panel', warranty: '12' },
        { key: 55, series: 'Solar Panel Series', item: 'EcoFlow HeatGuard Solar Film', warranty: '24' },
        { key: 56, series: 'Power Solutions Series', item: 'Power Hub', warranty: '5 years' },
        { key: 57, series: 'Power Solutions Series', item: 'Power Kits Console', warranty: '5 years' },
        { key: 58, series: 'Power Solutions Series', item: 'Power Link', warranty: '5 years' },
        { key: 59, series: 'Power Solutions Series', item: 'Power Dock', warranty: '5 years' },
        { key: 60, series: 'Power Solutions Series', item: '30A/50A Smart Distribution Panel', warranty: '5 years' },
        { key: 61, series: 'Power Solutions Series', item: '2kWh/5kWh LFP Battery', warranty: '5 years' },
        { key: 62, series: 'Power Solutions Series', item: 'Power Kits 5kVA 48V Power System', warranty: '5 years' },
        { key: 63, series: 'Power Solutions Series', item: 'Smart Home Panel', warranty: '3 years' },
        { key: 64, series: 'Power Solutions Series', item: 'Smart Home Panel 2', warranty: '10 years' },
        { key: 65, series: 'Power Solutions Series', item: 'Smart Home Panel 3', warranty: '10 years' },
        { key: 66, series: 'Power Solutions Series', item: 'Gateway', warranty: '10 years' },
        { key: 67, series: 'Power Solutions Series', item: 'EcoFlow Lithium 12V 100Ah Battery', warranty: '5 years' },
        { key: 68, series: 'Power Solutions Series', item: '12V trolling motor lithium battery', warranty: '5 years' },
        { key: 69, series: 'Power Solutions Series', item: '800W Alternator Charger', warranty: '24' },
        { key: 70, series: 'Power Solutions Series', item: '500W Alternator Charger', warranty: '24' },
        { key: 71, series: 'Power Solutions Series', item: 'PowerPulse EV Charger', warranty: '3 years' },
        { key: 72, series: 'Accessories', item: 'RAPID 20W Charger', warranty: '18' },
        { key: 73, series: 'Accessories', item: 'RAPID 30W Charger', warranty: '18' },
        { key: 74, series: 'Accessories', item: 'RAPID 65W Charger', warranty: '18' },
        { key: 75, series: 'Accessories', item: 'Power Hat', warranty: '12' },
        { key: 76, series: 'Accessories', item: 'Other Accessories', warranty: '12' },
        { key: 77, series: 'STREAM Series', item: 'STREAM Ultra', warranty: '10 years' },
        { key: 78, series: 'STREAM Series', item: 'STREAM Microinverter', warranty: '10 years' },
        { key: 79, series: 'TRAIL Series', item: 'TRAIL 200 DC', warranty: '3 years' },
        { key: 80, series: 'TRAIL Series', item: 'TRAIL 300 DC', warranty: '3 years' },
        { key: 81, series: 'Smart Devices Series', item: 'Smart Generator', warranty: '12' },
        { key: 82, series: 'Smart Devices Series', item: 'Smart Generator (Dual Fuel)', warranty: '24' },
        { key: 83, series: 'Smart Devices Series', item: 'Smart Generator 3000 (Dual Fuel)', warranty: '24' },
        { key: 84, series: 'Smart Devices Series', item: 'Smart Generator 4000 (Dual Fuel)', warranty: '3 Years' },
        { key: 85, series: 'Smart Devices Series', item: 'Wave Portable Air Conditioner', warranty: '12' },
        { key: 86, series: 'Smart Devices Series', item: 'Wave Add-On Battery', warranty: '12' },
        { key: 87, series: 'Smart Devices Series', item: 'WAVE 2', warranty: '12; or 12 +12 (Subject to registration)' },
        { key: 88, series: 'Smart Devices Series', item: 'Wave 3', warranty: '24' },
        { key: 89, series: 'Smart Devices Series', item: 'WAVE 3 Add-on Battery', warranty: '24' },
        { key: 90, series: 'Smart Devices Series', item: 'GLACIER', warranty: '12; or 12 +12 (Subject to registration)' },
        { key: 91, series: 'Smart Devices Series', item: 'GLACIER Plug-in Battery', warranty: '24' },
        { key: 92, series: 'Smart Devices Series', item: 'Glacier Classic', warranty: '24' },
        { key: 93, series: 'Smart Devices Series', item: 'Glacier Classic EB', warranty: '24' },
        { key: 94, series: 'Smart Devices Series', item: 'Blade', warranty: '36; or 36 +12 (Subject to registration)' },
        { key: 95, series: 'Power Bank Series', item: 'RAPID Pro X Power Bank (27,650mAh, 300W)', warranty: '24' },
        { key: 96, series: 'Power Bank Series', item: 'RAPID Pro Power Bank (27,650mAh, 300W, 140W Built-in Cable)', warranty: '24' },
        { key: 97, series: 'Power Bank Series', item: 'RAPID Pro Power Bank(20,000mAh, 230W, 100W Built-in Cable)', warranty: '24' },
        { key: 98, series: 'Power Bank Series', item: 'RAPID Pro 3-in-1 Power Bank (10,000mAh, 67W)', warranty: '24' },
        { key: 99, series: 'Power Bank Series', item: 'RAPID Power Bank (25,000mAh, 170W, 100W Built-In and Retractable Cables)', warranty: '24' },
        { key: 100, series: 'Power Bank Series', item: 'RAPID Power Bank (25,000mAh, 170W)', warranty: '24' },
        { key: 101, series: 'Power Bank Series', item: 'RAPID Magnetic Power Bank (5000mAh)', warranty: '24' },
        { key: 102, series: 'Power Bank Series', item: 'RAPID Magnetic Power Bank (10000mAh)', warranty: '24' },
        { key: 103, series: 'Power Bank Series', item: 'RAPID Mag Qi2.2 Magnetic Power Bank (10,000mAh, 25W, Built-in USB-C Cable)', warranty: '24' },
        { key: 104, series: 'Power Bank Series', item: 'RAPID Mag Qi2 Magnetic Power Bank (10,000mAh, 15W)', warranty: '24' },
        { key: 105, series: 'Power Bank Series', item: 'RAPID Mag Power Bank (5,000mAh, 7.5W)', warranty: '18' },
        { key: 106, series: 'Power Bank Series', item: 'RAPID Mag Power Bank (10,000mAh, 7.5W, Magnetic Charging)', warranty: '18' },
        { key: 107, series: 'Power Bank Series', item: 'RAPID Mag Qi2.2 Wireless Charging Station (3-in-1 Foldable)', warranty: '24' },
    ];

    // 一次遍历，计算所有的rowSpan
    const firstIdxMap: Record<string, number> = {};
    const idxMapRowSpan = new Map<number, number>();
    p2Data.forEach((curr, index) => {
        if (index > 0 && curr.series === p2Data[index - 1].series) {
            const firstIdx = firstIdxMap[curr.series];
            // 正常情况下 排好序的P2data，firstIdxMap[curr.series] 是一定存在的
            const firstIdxValue = idxMapRowSpan.get(firstIdx);
            if (firstIdx != null && firstIdxValue) {
                idxMapRowSpan.set(firstIdx, firstIdxValue + 1);
            } else {
                console.warn('firstIdxMap[curr.series] is not exist', curr.series, index);
            }
        } else {
            idxMapRowSpan.set(index, 1);
            firstIdxMap[curr.series] = index;
        }
    });

    const p2Colums: TableProps<WarrantyTableItem>['columns'] = [
        {
            title: 'Product Series',
            dataIndex: 'series',
            key: 'series',
            onCell: (_row: WarrantyTableItem, index: number | undefined) => {
                if (typeof index !== 'number') return {};
                const rowSpan = idxMapRowSpan.get(index) ?? 0;
                return { rowSpan };
            },
        },
        {
            title: 'Item',
            dataIndex: 'item',
            key: 'item',
        },
        {
            title: 'Warranty Period (refer to months, unless specified)',
            dataIndex: 'warranty',
            key: 'warranty',
        },
    ];

    const p4Colums = [
        {
            title: 'Product',
            dataIndex: 'product',
            key: 'Product',
        },
        {
            title: 'Shipping Cost',
            dataIndex: 'cost',
            key: 'Shipping Cost',
        },
    ];

    const p4Data = [
        {
            key: 1,
            product: 'DELTA',
            cost: '$65',
        },
        {
            key: 2,
            product: 'RIVER 370',
            cost: '$40 ',
        },
        {
            key: 3,
            product: 'RIVER',
            cost: '$30',
        },
        {
            key: 4,
            product: 'RIVER Extra Battery',
            cost: '$15',
        },
        {
            key: 5,
            product: 'RIVER Max',
            cost: '$35',
        },
        {
            key: 6,
            product: 'RIVER Pro',
            cost: '$35',
        },
        {
            key: 7,
            product: 'RIVER Pro Extra Battery',
            cost: '$35',
        },
        {
            key: 8,
            product: 'DELTA Max',
            cost: '$70',
        },
        {
            key: 9,
            product: 'DELTA Pro',
            cost: '$90',
        },
        {
            key: 10,
            product: 'RIVER Plus',
            cost: '$30',
        },
        {
            key: 11,
            product: 'RIVER Max Plus',
            cost: '$35',
        },
        {
            key: 12,
            product: '110W/160W solar panel',
            cost: '$40',
        },
        {
            key: 13,
            product: 'Other Products',
            cost: '$16',
        },
    ];
    const p5Colums = [
        {
            title: 'Warranty Item',
            dataIndex: 'wi',
            key: 'Warranty Item',
        },
        {
            title: 'Purchase Country/Region',
            dataIndex: 'pcr',
            key: 'Purchase Country/Region',
        },
        {
            title: 'Countries/Regions for International Warranty Service',
            dataIndex: 'crfiws',
            key: 'Countries/Regions for International Warranty Service',
        },
    ];

    const p5Data = [
        {
            key: 1,
            wi: 'Replacement Under Warranty',
            pcr: 'Supported',
            crfiws: 'Supported',
        },
        {
            key: 2,
            wi: 'Repair Under Warranty',
            pcr: 'Not Supported',
            crfiws: 'Not Supported',
        },
        {
            key: 3,
            wi: 'Return and Refund',
            pcr: 'Supported',
            crfiws: 'Not Supported',
        },
    ];
    const p5Colums_2 = [
        {
            title: 'Purchase Country/Region',
            dataIndex: 'pcr',
            key: 'Purchase Country/Region',
        },
        {
            title: 'Warranty Country/Region',
            dataIndex: 'wcr',
            key: 'Warranty Country/Region',
        },
        {
            title: 'Device Status',
            dataIndex: 'ds',
            key: 'Device Status',
        },
        {
            title: 'Eligible for International Warranty',
            dataIndex: 'efiw',
            key: 'Eligible for International Warranty',
        },
        {
            title: 'Warranty Rule for Main Device After Service',
            dataIndex: 'wrfmdas',
            key: 'Warranty Rule for Main Device After Service',
        },
        {
            title: 'Remarks',
            dataIndex: 'remarks',
            key: 'Remarks',
        },
    ];

    const p5Data_2 = [
        {
            key: 1,
            pcr: locale === 'ca' ? 'Canada' : 'United States',
            wcr: 'Germany',
            ds: 'Within Warranty',
            efiw: 'Yes',
            wrfmdas: 'Continues original warranty period',
            remarks: 'Warranty is based on the rules of the purchase country/region (United States)',
        },
        {
            key: 2,
            pcr: 'United States',
            wcr: 'South Africa',
            ds: 'Within Warranty',
            efiw: 'No',
            wrfmdas: '/',
            remarks:
                'Warranty country/region is not within the supported international warranty service area; service must be done in the original purchase country',
        },
    ];
    const tabActiveN = `p${parseInt(tabActive) + 1}`;
    if (id === 'p1') {
        return (
            <div id={id} key={id} className={`${tabActiveN == id ? 'policycontent-item active' : 'policycontent-item'}`}>
                <h3 style={{ marginTop: 0 }}>Overview</h3>
                1.1 Purpose
                <br />
                This policy aims to improve your after-sales experience and standardize processes in order to provide high-quality and efficient services.
                <br />
                <br />
                1.2 Applicable Customers
                <br />
                Applicable customers are those who have purchased an EcoFlow product in the {NA_Text} region and request after-sales service directly from
                EcoFlow. If you purchased through other e-commerce platforms or sales channels with different after-sales policies, please contact your place of
                purchase to handle your warranty.
                <br />
                <br />
                NA Region Scope: The Contiguous US
                <br />
                <br />
                1.3 NA After-Sales Service Contact Information
                <br />
                NA customers can reach EcoFlow via the following contact information:
                <br />
                Phone Number: +1 (800)-368-8604 (9 AM-9 PM EST)
                <br />
                Email: support@ecoflow.com
                <br />
                Ecoflow.com Online Support: Mon-Fri 10 AM-7 PM (EST)
                <br />
                EcoFlow App: https://ecoflow.com/pages/ecoflow-app
                <br />
                <br />
                <br />
                1.4 Product Series
                <br />
                <br />
                <Table columns={p1Columns} dataSource={p1Data} pagination={false} bordered={true} />
                <br />
                <br />
                *Table updated September 2021
            </div>
        );
    } else if (id === 'p2') {
        return (
            <div id={id} key={id} className={`${tabActiveN == id ? 'policycontent-item active' : 'policycontent-item'}`}>
                <h3>Warranty Period</h3>
                2.1 The Warranty Period starts from the date of deliveryto the original end user purchaser.
                <a href={`https://www.ecoflow.com/${countryText}/support/warranty`}> Register your Product Here</a> for an extended warrainty period, as stated below. (Only
                specific Product models are availablefor extension)
                <br />
                <br />
                <TableV5 columns={p2Colums} dataSource={p2Data} pagination={false} bordered={true} rowKey="key" />
                {/* <br />
                *Table updated September-2021;
                <br />
                **For DELTA Pro & DELTA Max/RIVER/DELTA series Kickstarter backers, EcoFlow offers an exclusive warranty period based on campaign commitment. */}
                <br />
                <br />
                2.2 How To Make A Claim Under The Limited Warranty
                <br />
                If you wish to make a warranty claim, please contact us（<a href="mailto:support@ecoflow.com">support@ecoflow.com</a>） or your local authorized
                service company/distributor. Upon contacting us or your authorized service company/distributor, please have the serial number of your Product
                ready and the original proof of purchase and/or proof of delivery from Ecoflow authorized seller/dealer/reseller, showing the date of
                purchase/delivery andfull details of the Product. Our colleagues will advise you of the process involved in making a claim.
                <br />
                Any claim under this Limited Warranty is subject to you notifying us(or our authorized service company/distributor) of the alleged defect within
                a reasonable time of it coming to your attention and, in any case, by no later than the expiry of the Warranty Period. If EcoFlow determines
                that any Product is not covered by this Limited Warranty, you must pay all parts, shipping, and labor charges for the repair or return of such
                Product.
                <br />
                Warranty service can only be performed by an EcoFlow authorized service center. The original dated bill of sale and/or proof of delivery must be
                presented upon request to EcoFlow or EcoFlow’s authorized service center.
                <br />
                <br />
                2.3 Remedies If a claim is received within the Warranty Period and the Product is found to have failed under the Warranty, we shall, at our
                option:
                <br />
                <ul style={{ listStyleType: 'disc', paddingLeft: '1em' }}>
                    <li style={{ listStyleType: 'round' }}>
                        repair the Product（In addition, brand-new or refurbished parts that have been tested and found to meet quality standards may be used
                        during the repair process.）, or
                    </li>
                    <li style={{ listStyleType: 'round' }}>
                        EcoFlow may replace this product with a new or refurbished unit of the same or a different model. The replacement product shall have
                        equivalent functionality and performance to the original product, and refurbished products shall have been tested and found to meet
                        EcoFlow’s functional requirements, or
                    </li>
                    <li style={{ listStyleType: 'round' }}>Refund, partly or fully, your purchase price in exchange for the return of your Product.</li>
                </ul>
                <br />
                As far as applicable laws permit, the warranty period will not be extended, renewed, or otherwise affected by any subsequent replacement,
                resale, repair, or exchange of the product. For products or parts repaired or replaced during the warranty period, the warranty period shall be
                the remaining term of the original warranty or ninety (90) days from the date of repair or replacement, whichever is longer.
                <br />
                The repaired or replaced product (as applicable) will be returned to you as soon as commercially feasible. All replaced products or parts
                (including parts removed during the repair or replacement process) become our property. If the product is found to be outside the scope of this
                Limited Warranty, we (and our authorized service providers/dealers) reserve the right to charge a service fee（shipping, and labor costs, etc）.
                <br />
                When providing repair or replacement services, EcoFlow may use new products or parts, or refurbished/repaired products or parts that are
                equivalent in performance and reliability to new ones or have been tested to meet quality standards. If after-sales service is requested in a
                country or region other than the country where the EcoFlow product was purchased, EcoFlow may use equivalent products and parts that comply with
                local standards to repair or replace the product. When providing after-sales service, the EcoFlow products or replacement parts used by EcoFlow
                may originate from a country different from the country of origin of the product or the original parts.
                <br />
                <br />
                2.4 Warranty Service Options
                <br />
                Currently, EcoFlow will only provide warranty service through Mail-in service. EcoFlow will send you prepaid waybills/shipping labels as long as
                EcoFlow’s shipping service is available and, if applicable, EcoFlow will send you instructions on how to properly pack and address your product,
                so that you may ship your Product to our designated service location.
                <br />
                Once service is completed, EcoFlow or EcoFlow authorized service center will return the Product to you. EcoFlow will pay for shipping to and
                from your location if all instructions regarding the method of packaging and shipping the Product are followed.
                <br />
                Please ensure that you provide accurate and complete information to EcoFlow for the shipping to and from your location. Otherwise, you shall be
                responsible for any delays, additional costs, or losses arising therefrom, as well as any losses incurred by EcoFlow.
                <br />
                For repair services involving replacement of products, parts, or accessories, EcoFlow reserves the right to require you to return the relevant
                items in advance as a condition for providing replacement products, parts, or accessories. If you fail to return such items as required, or if
                the returned items do not meet the conditions of this warranty, EcoFlow reserves the right to refuse warranty service or take other reasonable
                measures.
                <br />
                <br />
                2.5 What Is Not Covered By This Warranty
                <br />
                This warranty does not apply to any non-EcoFlow branded hardware products or any software, even if packaged or sold with EcoFlow hardware.
                EcoFlow may restrict warranty service for specific Product to countries where EcoFlow or its Authorized distributors/resellers sell the device.
                <br />
                This Limited Warranty is conditioned upon proper use of the Product. This Limited Warranty does not cover:
                <br />
                a) normal wear and tear (including, without limitation, wear and tear of batteries, if applicable).
                <br />
                b) defects caused by rough or inappropriate handling or use or damage caused by accident, misuse, negligence, fire, water, lightning or other
                acts of nature.
                <br />
                c) if the Product contains a battery and the battery has been short-circuited, if the seals of the battery enclosure or the cells are broken or
                show evidence of tampering or if the battery has been used in equipment other than those for which it has been specified.
                <br />
                d) non-compliance with the Product instructions. e) willful or deliberate damage, neglect or negligence.
                <br />
                f) use of spare parts, or other replacement items (including consumables) which are not provided or recommended by us. g) any alteration or
                modification to the Product which has been carried out by you or a third party not authorized by us.
                <br />
                h) any failure to adequately package the Product for transportation. i) extreme or external causes beyond our reasonable control including, but
                not limited to, breakdowns, fluctuations, or interruptions in electric power, or wireless networks.
                <br />
                j) operation or use in bad weather (i.e. strong winds, rain, sand/dust storms, etc.). k) any Product(s) purchased from unauthorized
                sellers/dealers/resellers.
                <br />
                l) use or operate in an environment with electromagnetic interference (i.e. In mining areas or close to radio transmission towers, high-voltage
                wires, substations, etc.). m) unauthorized modification of circuits and mismatch or misuse of the battery and charger.
                <br />
                n) connection to an improper power supply. o) use of the equipment in conjunction with third-party accessories, products, or ancillary
                peripheral equipment. p) equipment where the manufacturer’s serial number has been altered, deleted, removed, or made illegible.
                <br />
                q) equipment which has been adjusted or adapted without EcoFlow’s prior written consent, including (but not limited to): upgrading the equipment
                beyond specifications or features described in the instruction manual, or modifications to the equipment to conform it to national or local
                technical or safety standards in countries other than those for which the equipment was specifically designed and manufactured. r) consumable
                parts.
                <br />
                s) products that are lost, stolen, or provided free of charge, including promotional or giveaway items.
                <br />
                t) any Product whose warranty period has expired.
                <br />
                u) any Product for which you fail to provide valid proof of purchase and/or proof of delivery.
                <br />
                v) damage or loss to any software programs, data, or removable storage media costs associated with de-installation, re-installation, or
                integration into a system.
                <br />
                <br />
                2.6 Limitations Of EcoFlow’s Liability
                <br />
                This Limited Warranty is your sole and exclusive remedy against EcoFlow and EcoFlow’s sole and exclusive liability in respect of defects in your
                Product. This Limited Warranty replaces all other EcoFlow warranties and liabilities, whether oral, written, (non-mandatory) statutory,
                contractual, in tort or otherwise, including, without limitation, and where permitted by applicable law, any implied conditions, warranties or
                other terms as to satisfactory quality or fitness for purpose, except as otherwise provided in any specific warranty.
                <br />
                However, this Limited Warranty shall neither exclude nor limit (i) any of your legal (statutory) rights under the applicable national laws, or
                (ii) any of your rights against the seller of the Product.
                <br />
                To the extent permitted by applicable law(s), EcoFlow does not assume any liability for loss of or damage to or corruption of data, for any loss
                of profit, loss of use of Products or functionality, loss of business, loss of contracts, loss of revenues or loss of anticipated savings,
                increased costs or expenses or for any indirect loss or damage, consequential loss or damage or special loss or damage.
                <br />
                To the extent permitted by applicable law, EcoFlow´s liability shall be limited to the purchase value of the Product. The above limitations
                shall not apply in case of gross negligence or intentional misconduct of EcoFlow or in case of death or personal injury resulting from EcoFlow’s
                proven negligence.
                <br />
                ECOFLOW DISCLAIMS ANY EXPRESS WARRANTY NOT PROVIDED HEREIN AND ANY IMPLIED WARRANTY, GUARANTEE OR REPRESENTATIONS AS TO THE SUITABILITY FOR ANY
                PARTICULAR PURPOSE, PERFORMANCE, QUALITY AND ABSENCE OF HIDDEN DEFECTS, AND ANY REMEDY FOR BREACH OF CONTRACT, WHICH BUT FOR THIS PROVISION,
                MIGHT ARISE BY IMPLICATION, OPERATION OF LAW, CUSTOM OF TRADE OR COURSE OF DEALING, INCLUDING IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS
                FOR A PARTICULAR PURPOSE. EXCEPT AS PROVIDED IN THIS AGREEMENT, ECOFLOW FURTHER DISCLAIMS ANY RESPONSIBILITY FOR LOSSES, EXPENSES,
                INCONVENIENCES, SPECIAL, INDIRECT, SECONDARY, OR CONSEQUENTIAL DAMAGES ARISING FROM OWNERSHIP OR USE OF THE PRODUCTS.
                <br />
                <br />
                2.7 General
                <br />
                If any term is held to be illegal or unenforceable by force of law, it will be excluded from the warranty and the legality or enforceability of
                the remaining terms shall not be affected.
                <br />
                Please note: All claims made under this Limited Warranty will be governed by the terms set out in this warranty document. This limited warranty
                supersedes all previous EcoFlow warranty statements or other marketing materials.
                <br />
                <br />
                2.8 Limited Warranty For Smart Home Panel 2
                <br />
                The EcoFlow Smart Home Panel 2 is covered by a limited warranty, for details, please visit{' '}
                <a href={`https://${countryText}.ecoflow.com/pages/ecoflow-smart-home-panel-2`}>https://{countryText}.ecoflow.com/pages/ecoflow-smart-home-panel-2</a>.
                <br />
                This specific warranty shall prevail in the event of any inconsistency with this Limited Warranty.
                <br />
                <br />
                2.9 EcoFlow Installation Warranty Policy
                <br />
                For details, please visit{' '}
                <a href={`https://${countryText}.ecoflow.com/pages/installation-terms-conditions`}>https://{countryText}.ecoflow.com/pages/installation-terms-conditions</a>
                <br />
                This specific warranty shall prevail in the event of any inconsistency with this Limited Warranty.
                <br />
                <br />
                2.10 APPLICABLE LAW
                <br />
                This warranty gives you specific legal rights, and you may also have other rights which vary from Jurisdiction to Jurisdiction. The terms of
                this Limited Warranty will apply to the extent permitted by applicable law.
                <br />
                <br />
            </div>
        );
    } else if (id === 'p4') {
        return (
            <div id={id} key={id} className={`${tabActiveN == id ? 'policycontent-item active' : 'policycontent-item'}`}>
                <h3>Repair Service</h3>
                4.1 Warranty Repair Service
                <br />
                a. If the product is under warranty, the customer can request EcoFlow to repair their product in the event that it is not functioning as
                intended;
                <br />
                b. The customer can request repair when the following conditions are met:
                <br />
                √The product has a manufacturing defect during the warranty period.
                <br />
                √A valid proof-of-purchase, receipt, or order number for the warranty service is provided.
                <br />
                c. In the following cases, EcoFlow will not be able to provide free warranty services for your product during the warranty period:
                <br />
                a. The warranty period of the product has expired.
                <br />
                b. Unable to provide proof of purchase and relevant documents, or unable to prove that the product is within the warranty period.
                <br />
                c. Product identification information (such as barcodes, model numbers, warning icons, etc.) has been altered or worn off.
                <br />
                d. Unauthorized modifications to product software or hardware, use of unofficial or unauthorized accessories, third-party devices, use of the
                product under conditions not recommended by the official guidelines, and any damage caused by failure to follow instructions in the quick guide,
                user manual (or other relevant documents), improper use, maintenance, etc.
                <br />
                e. Damage caused by force majeure (including but not limited to earthquakes, fires, floods, war, lightning strikes, theft, etc.).
                <br />
                f. Any failure or damage to the product caused by external factors such as collisions and burns, including but not limited to exposure to high
                temperature and humidity, oily or smoky environment, intrusion of foreign substances (liquids, corrosive substances, oxidation, insects, sand,
                etc.), improper installation or operation.
                <br />
                g. Damage caused by repairs by persons or institutions not authorized by EcoFlow.
                <br />
                h. Natural damages to the surface of the product (abrasions, scratches, etc.) that do not affect its functionality and normal usage.
                <br />
                i. Unauthorized alteration of warranty cards or warranty statements.
                <br />
                j. The product has been found to be free from defects after all appropriate testing performed by EcoFlow or a repair service center authorized
                by EcoFlow.
                <br />
                k. Products that have been modified or disassembled without authorization.
                <br />
                l. Products purchased from unauthorized resellers.
                <br />
                m. Non-commercial versions of the product are not covered by the warranty.
                <br />
                n. The product has not been sent back to EcoFlow 15 calendar days after warranty repair confirmation from EcoFlow.
                <br />
                o. Complimentary gifts included with the order are not covered under EcoFlow's commercial warranty policy and do not affect the statutory rights
                enjoyed by consumers in accordance with the law.
                <br />
                p. Other circumstances not listed in this Policy but EcoFlow has reasonable grounds to refuse the request.
                <br />
                4.2 Paid Repair
                <br />
                Paid repair is required in the following situations:
                <br />
                a. The product warranty has expired.
                <br />
                b. All conditions that do not belong to Warranty Repair Service.
                <br />
                4.3 Quotation criterion of paid repair.
                <br />
                Paid repair is required for conditions that are not covered by Warranty Repair Service. Reasonable cost will be charged for the following
                categories:
                <br />
                a. Spare parts cost.
                <br />
                b. Labor cost.
                <br />
                c. Logistics cost.
                <br />
                Logistics costs can be referenced. Cost is based on the weight and volume of the product:
                <br />
                <br />
                <Table columns={p4Colums} dataSource={p4Data} pagination={false} bordered={true} />
            </div>
        );
    } else if (id === 'p5') {
        return (
            <div id={id} key={id} className={`${tabActiveN == id ? 'policycontent-item active' : 'policycontent-item'}`}>
                <h3>Limited International Warranty Service</h3>
                <span className="bold-font">Policy Overview</span>
                <br />
                <div>
                    <p>
                        The international warranty service for EcoFlow products is designed for users who use the products outside of the original purchase
                        location. To provide a premium service experience, consumers can enjoy this warranty service for designated devices in specific
                        countries/regions that support international warranty services.
                    </p>
                </div>
                <br />
                <span className="bold-font">Countries/Regions Supporting International Warranty</span>
                <div>
                    <p>
                        Asia: <span className="bold-font">Mainland China</span> (excluding Hong Kong, Macao, and Taiwan),{' '}
                        <span className="bold-font">Japan, South Korea</span>
                    </p>
                    <p>
                        Europe: <span className="bold-font">Germany, the United Kingdom</span> (excluding British Overseas Territories),
                        <span className="bold-font"> France</span> (excluding French Overseas Territories), <span className="bold-font">Italy, Spain</span>{' '}
                        (excluding Spanish Overseas Territories)
                    </p>
                    <p>
                        North America: <span className="bold-font">Canada, United States </span>(excluding Puerto Rico, Guam, Hawaii, and Alaska)
                    </p>
                    <p>
                        Oceania: <span className="bold-font">Australia</span>
                    </p>
                    <p>
                        * Devices must be within the Warranty Period, and both the purchase location and the service location must be within the above-listed
                        countries/regions to be eligible for international warranty service.
                    </p>
                    <p>
                        * French Overseas Territories: New Caledonia, Wallis and Futuna, French Polynesia, Clipperton Island, Mayotte, Réunion, Saint Pierre and
                        Miquelon, French Guiana, Saint Martin (French part), Saint Barthélemy, Guadeloupe, Martinique.
                    </p>
                    <p>* Spanish Overseas Territories: Canary Islands, Ceuta, and Melilla.</p>
                    <p>
                        * British Overseas Territories: Anguilla, Bermuda, British Virgin Islands, Cayman Islands, Montserrat, Turks and Caicos Islands,
                        Falkland Islands, South Georgia and the South Sandwich Islands, Saint Helena, Gibraltar, British Antarctic Territory, Pitcairn Islands,
                        Akrotiri and Dhekelia.
                    </p>
                </div>
                <br />
                <span className="bold-font">International Warranty Scenarios and Service Coverage</span>
                <br />
                <br />
                <Table columns={p5Colums} dataSource={p5Data} pagination={false} bordered={true} />
                <br />
                <div>
                    <p>
                        <span className="bold-font">Eligible Users: </span>All consumers who purchase through EcoFlow or EcoFlow's officially authorized
                        channels (including new and refurbished devices).
                    </p>
                    <p>
                        <span className="bold-font">Supported Models: </span>EcoFlow RAPID Pro Power Bank (20,000mAh, 230W, 100W Built-in Cable), EcoFlow RAPID
                        Pro Power Bank (27,650mAh, 300W, 140W Built-in Cable), EcoFlow RAPID Pro X Power Bank (27,650mAh, 300W).
                    </p>
                    <p>
                        <span className="bold-font">Warranty Within Coverage: </span>Consumers must provide valid proof of purchase (electronic or paper
                        invoice, order number, etc.) and the device serial number. Upon confirmation by the local official customer service that warranty
                        conditions are met, consumers are eligible for&nbsp;
                        <span className="bold-font">
                            International warranty service (which covers main device hardware only; and accessories and software are excluded).{' '}
                        </span>
                        Warranty determination is subject to the policies of EcoFlow&apos;s local service center. Devices or part(s) repaired or replaced during
                        the Warranty Period will be warranted for the remainder of the original Warranty Period from the date of repair or replacement.
                    </p>
                    <p>
                        <span className="bold-font">Warranty Scope: </span>Hardware damage or functional failure caused by product quality issues.
                    </p>
                    <p>
                        <span className="bold-font">Warranty Period: Determined by the device&apos;s original purchase location</span> (effective from the date
                        of purchase), unless otherwise required by local laws and regulations. Replacement devices inherit the remaining Warranty Period of the
                        original product and will not restart the warranty duration. If the purchase date cannot be confirmed, the Warranty Period will start
                        from the manufacturing date (based on serial number) plus 90 days.
                    </p>
                    <p>
                        <span className="bold-font">Local Warranty Service: </span>Follows the existing warranty policy of the product&apos;s purchase
                        country/region.
                    </p>
                    <p>
                        * The length of warranty coverage and post-replacement warranty duration are subject to the relevant laws and regulations of the
                        country/region. In case of conflict, local laws and regulations prevail.
                    </p>
                </div>
                <br />
                <span className="bold-font"> Warranty Exclusions</span>
                <div>
                    <p>
                        <span className="bold-font">The following scenarios are not covered under the international warranty:</span>
                    </p>
                    <br />
                    <p>1. Device models that do not support international warranty;</p>
                    <p>2. Failure to provide valid proof of purchase;</p>
                    <p>3. Service location outside the eligible coverage area;</p>
                    <p>4. Devices sold through unofficial or unauthorized channels;</p>
                    <p>5. Any unauthorized modification, disassembly, or repair without EcoFlow’s permission;</p>
                    <p>6. Lost or stolen products;</p>
                    <p>7. Damage caused by misuse (including but not limited to dropping, water damage, extreme temperatures, improper operation);</p>
                    <p>8. External damages (including but not limited to natural disasters such as earthquakes, tsunamis, tornadoes);</p>
                    <p>9. Non-quality-related issues;</p>
                    <p>10. Products that have exceeded the Warranty Period;</p>
                    <p>11. Free products;</p>
                    <p>12. Return and refund services.</p>
                </div>
                <br />
                <span className="bold-font"> Policy Description</span>
                <div>
                    <p>
                        1. The international warranty service only covers warranty support for designated models (main device hardware only, excluding
                        accessories and software). It does not include return or refund services. Other services are subject to the policies of the service
                        location.
                    </p>
                    <p>2. Accessory warranties are subject to the service policy of the purchase location.</p>
                    <p>
                        3. This international warranty policy does not affect consumers' existing warranty rights in the country/region where the product was
                        purchased.
                    </p>
                    <p>
                        4. The start date of international warranty service in each country/region is based on the official product release date in that
                        country/region.
                    </p>
                    <p>
                        5. You must authorize EcoFlow to access your relevant information and provide necessary warranty details; otherwise, EcoFlow’s official
                        service center reserves the right to refuse service.
                    </p>
                    <p>
                        6. For devices purchased through unauthorized channels, service centers reserve the right to refuse service. Please purchase products
                        through officially recognized channels.
                    </p>
                    <p>
                        7. If the product has quality defects or flaws during the warranty period and does not fall into the above exclusion scenarios, and if
                        it cannot be repaired after inspection by EcoFlow, EcoFlow has the right to choose to replace it with a new device of the same model or
                        a refurbished device of the same model for you.
                    </p>
                    <p>
                        8. Any defective product that is replaced becomes the property of EcoFlow. You must return it according to EcoFlow’s instructions. If
                        you do not follow the return instructions or refuse to return the product, EcoFlow reserves the right to deny any further claims,
                        including refusing to provide warranty service for the replacement unit.
                    </p>
                    <p>
                        9. Due to differences in systems, regulations, product versions, and packaging requirements between countries/regions, the process and
                        outcome of this service may lead to differences in packaging, appearance, or features. Safety certifications or markings printed on the
                        product or packaging may apply only in the region providing the warranty service and may differ from those required in the purchase
                        location.
                    </p>
                    <p>
                        10. When carrying the product across borders, users must comply with local customs laws and regulations and bear any resulting costs and
                        duties.
                    </p>
                    <p>
                        11. Supported device models and countries/regions under this service are subject to change. Please refer to the latest official
                        announcements.
                    </p>
                    <p>12. The information on this page is subject to change without prior notice. EcoFlow reserves the right to the final interpretation.</p>
                </div>
                <br />
                <span className="bold-font"> Email Us</span>
                <div>
                    <p>
                        <span className="bold-font">NA: </span>
                        <a href="mailto:support@ecoflow.com">support@ecoflow.com</a>
                    </p>
                    <p>
                        <span className="bold-font">DE/UK/FR/IT/ES: </span>
                        <a href="mailto:support.eu@ecoflow.com">support.eu@ecoflow.com</a>
                    </p>
                    <p>
                        <span className="bold-font">AU: </span>
                        <a href="mailto:support.au@ecoflow.com">support.au@ecoflow.com</a>
                    </p>
                    <p>
                        <span className="bold-font">JP: </span>
                        <a href="mailto:support.jp@ecoflow.com">support.jp@ecoflow.com</a>
                    </p>
                    <p>
                        <span className="bold-font">KR: </span>
                        <a href="mailto:support.kr@ecoflow.com">support.kr@ecoflow.com</a>
                    </p>
                    <p>
                        <span className="bold-font">CN: </span>
                        <a href="mailto:guoneikefu@ecoflow.com">guoneikefu@ecoflow.com</a>
                    </p>
                </div>
                <br />
                <span className="bold-font">Appendix: Cross-Country/Region Warranty Examples</span>
                <br />
                <br />
                <Table columns={p5Colums_2} dataSource={p5Data_2} pagination={false} bordered={true} />
            </div>
        );
    }
    return <div></div>;
}

function scrollToAnchor(target: string) {
    const ele: any = document.querySelector(target);
    const container: any = document.querySelector('#container');
    if (ele) {
        container.scrollTop = ele.offsetTop - 68;
    }
}
